const constant = {
  companyId: {
    housing: 611174,
    makaan: 112548
  },
  masterRoles: {
    housing: [
      {
        roleId: 1040,
        name: 'LOOKUP_MASTER_DATA',
        value: 'LOOKUP_MASTER_DATA'
      },
      {
        roleId: 100,
        name: 'Housing Sales Manager',
        value: 'Housing Sales Manager'
      },
      {
        roleId: 101,
        name: 'Housing Sales Agent',
        value: 'Housing Sales Agent'
      },
      {
        roleId: 1001,
        name: 'Ap Admin',
        value: 'Ap Admin'
      },
      {
        roleId: 134,
        name: 'TENANT_MONETIZATION_AGENT',
        value: 'TENANT_MONETIZATION_AGENT'
      },
      {
        roleId: 1008,
        name: 'Lookup View',
        value: 'LOOKUP VIEW'
      },
      {
        roleId: 1013,
        name: 'Lead Delivery SPOC',
        value: 'Lead Delivery SPOC'
      },
      {
        roleId: 1043,
        name: 'Audience Maximizer Agent',
        value: 'Audience Maximizer Agent'
      }
    ],
    makaan: [
      {
        roleId: 117,
        name: 'Makaan Sales Agent',
        value: 'MakaanSalesAgent'
      },
      {
        roleId: 118,
        name: 'Makaan Sales Manager',
        value: 'MakaanSalesManager'
      }
    ]
  },
  isEmailValid: email => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return email ? re.test(email.trim()) : true
  },
  isValidPhone: number => {
    const re = /^\d{10}$/
    return re.test(number.trim())
  },
  isValidName: string => {
    string = string.replace(/\s/g, '')
    const regex = /^[a-zA-Z]+$/
    return regex.test(string.trim())
  },
  adminRole: 'Admin',
  lookupAdminRole: 'Lookup Admin',

  additionalAdminRoles: [
    'Tele-Sales Agent',
    'Tele-Sales Team Leader',
    'Tele-Sales Process Owner',
    'Owner Online Assist',
    'Owner Field Assist',
    'Broker Tele-Sales',
    'Broker Tele-Sales Team Lead',
    'Broker Tele-Sales Process Manager',
    'Broker Tele-Sales Business Manager',
    'Builder Tele-Sales',
    'Builder Tele-Sales Team Lead',
    'Builder Tele-Sales Process Manager',
    'Builder Tele-Sales Business Manager'
  ],
  additionalLkpAdminRoles: ['Housing Owner Manager'],
  HousingSalesManagerRoleIds: [
    'Housing Sales Manager',
    'Broker Tele Sales Team Lead',
    'Broker Tele Sales Process Manager',
    'Broker Tele Sales Business Manager',
    'Builder Tele Sales Team Lead',
    'Builder Tele Sales Process Manager',
    'Builder Tele Sales Business Manager'
  ],
  MakaanSalesManagerRoleIds: ['MakaanSalesManager'],
  getErrorMessage: (err, customAuthMsg = '') => {
    let errorMessage
    if (err) {
      if (err.response) {
        const { status, data } = err.response
        if ([400, 401, 422, 500].indexOf(status) !== -1) {
          errorMessage =
            (status === 401 && customAuthMsg) ||
            (data && data.error && data.error.msg) ||
            (status === 422 &&
              data &&
              data.api_errors &&
              data.api_errors.details) ||
            (status === 500 &&
              data &&
              data.api_errors &&
              data.api_errors.details) ||
            (data && data.api_errors && data.api_errors.display_phrase) ||
            (data && data.apiErrors && data.apiErrors.displayPhrase) ||
            (data &&
              data.message &&
              Array.isArray(data.message) &&
              data.message[0]) ||
            (data &&
              data.message &&
              typeof data.message === 'string' &&
              data.message) ||
            err.message
        }
      } else if (err.message) {
        return err.message
      }
    }
    return errorMessage || 'Alas! Some error occurred.'
  },
  style: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }
}

export default constant



/** WEBPACK FOOTER **
 ** ./src/containers/UserManagement/contants.js
 **/